<template>
  <div>
    <!-- 腾讯选址组件 -->
    <iframe
      class="ifram"
      :src="`https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=V4RBZ-ACNC3-5PS3C-3PJCV-MNMGH-OVF76&referer=myapp$coord=${coord}`"
      frameborder="0"
      allow="geolocation"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return {
      num: 0,
      coord: "",
    };
  },
  beforeMount() {
    this.init();
    this.coord = this.$store.state.coord;
  },
  methods: {
    init() {
      window.addEventListener("message", this.getLocation);
    },
    getLocation(event) {
      var _this = this;
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data;
      if (loc && loc.module == "locationPicker") {
        //防止其他应用也会向该页面post信息，需判断module是
        this.$emit("getLocation", loc);
        window.removeEventListener("message", this.getLocation);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.ifram {
  width: 100%;
  min-height: 100vh;
}
</style>